"use client";

import createIcon from './util/createIcon';
export default createIcon('M18 14H14V18H10V14H6V10H10V6H14V10H18', 'Hospital');